<template>
  <c-view>
    <c-page  class="s-actionsheet-container">
      <c-navbar title="续费中心">
      </c-navbar>
      <c-content>
        <div class="header">
          <span class="storeName">{{shopName}} <img src="../../assets/images/newrenew/vipwei.png" alt=""></span>
          <span class="storeInfo"><span style="color:#EEAF8C;">{{versionInfo.versionName}}</span><span v-if="Number(versionInfo.leftDays) >= 0">将于</span><span style="color:#EEAF8C;" v-if="Number(versionInfo.leftDays) >= 0">{{Number(versionInfo.leftDays) === 0 ? '今' : versionInfo.leftDays}}天后</span><span v-else>已</span>到期
          </span>
        </div>
        <div class="version__box">
          <div class="layout">
            <!-- <span style="version__header">选择付费方式</span> -->
            <div class="choose__version">
              <span class="version__item" v-for="(item, index) in versionInfo.busItems" :key="index" @click.passive="chooseItems(item)" v-if="ifShowLong(item)">
                <span class="choose__top"  :class="[item.choose ? 'active': '']">
                  <span class="top__word">
                    {{item.display || '-'}}
                    <!-- === 1 ? '按年续费' : '终身版' -->
                  </span>
                  <span class="top__price">
                    <span class="top__price-symbol">￥</span>{{item.finalAmount}}
                  </span> 
                  <span class="top__original" v-if="Number(item.discount) !== 0">￥{{item.originalAmount}}</span>
                  <span class="top__original" v-else></span>
                </span>
                <span class="choose__bottom"  :class="[item.choose ? 'active__bottom': '']">{{ item.type === 1 ? '开启好生意' : `以后无需再付费` }}</span>
                <img src="../../assets/images/newrenew/chaozhi.png" alt="" class="top__icon" v-if="Number(item.type) === 1">
                <img src="../../assets/images/newrenew/shihui.png" alt="" class="top__icon" v-if="Number(item.type) === 2">
              </span>
            </div>
          </div>
        </div>
        <div class="limit-box"></div>
      </c-content>
      <c-footer>
          <div class="renewnew__btn">
          <span class="renew__price">
            <span>仅需:<span style="color:#EDAC89;" class="price__amount"><span class="price__smallsymobl">￥</span>{{priceInfo.finalAmount}}</span></span>
            <span v-if="Number(priceInfo.discount) > 0">已减￥{{priceInfo.discount}}</span>
          </span>
          <span class="renew__btn" @click="sureDialog = true">
            立即续费
          </span>
        </div>
        </c-footer>
        <c-action-sheet :visible.sync="sureDialog">
          <div class="action-box">
            <div class="action__header">确认支付</div>
            <div class="action__content">
              <div class="content__all">
                  <span class="content__allinfo">仅需</span>
                  <span class="content__allprice">
                    <span style="color:#FF6A3C;">{{priceInfo.finalAmount}}<span class="amount__symobl">元</span></span>
                    <span v-if="Number(priceInfo.discount) > 0">优惠已减：{{priceInfo.discount}}元</span>
                  </span>
              </div>
              <div class="paytype">
                <span class="ali" @click="chooseali = true; choosewx = false">
                  <img src="../../assets/images/newrenew/ali.png" alt="" class="ali-icon">
                  <span class="paytype__word">支付宝支付</span>
                  <img src="../../assets/images/newrenew/choose.png" alt="" class="choose" v-if="chooseali">
                  <img src="../../assets/images/newrenew/nochoose.png" alt="" class="choose" v-else>
                  
                </span>
                <span class="wx" @click="choosewx = true; chooseali = false">
                  <img src="../../assets/images/newrenew/wx.png" alt="" class="wx-icon">
                  <span class="paytype__word">微信支付</span>
                  <img src="../../assets/images/newrenew/choose.png" alt="" class="choose"  v-if="choosewx">
                  <img src="../../assets/images/newrenew/nochoose.png" alt="" class="choose" v-else>              
                </span>
              </div>
              <div class="sureBtn" @click="renewNow">确认支付</div>
            </div>
          </div>
        </c-action-sheet>
    </c-page>
  </c-view>
</template>

<script>
import Rewewal from '../../model/newrenew/index'
import Pay from '../../model/pay'
import api from '@/tools/api-tools'
import { mainWeb } from '@/config/net'
import ActionModal from '../tabs/2018-05-18/real-sale/action-modal/index.vue'
export default {
  name: 'Newrenew',
  components: { ActionModal },
  data () {
    return {
      versionInfo: {},
      priceInfo: {
        price: null,
        discount: null
      },
      sureDialog: false,
      choosewx: false,
      chooseali: true,
      shopName: ''
    }
  },
  mounted () {
    this._getVersionInfo()
    api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=233`)
  },
  methods: {
    async _getVersionInfo () {
      const data = await Rewewal.getCurrentVersionInfo()
      this.versionInfo = data.data
      data.data.busItems.forEach(item => {
        item.choose = false
      })
      data.data.busItems[0].choose = true
      this.priceInfo = data.data.busItems[0]
      if (!this.versionInfo.shopName) {
        this.shopName = this.versionInfo.shopName
        return
      }
      this.shopName = this.versionInfo.shopFullName
    },
    chooseItems (value) {
      this.versionInfo.busItems.forEach(item => {
        item.choose = false
      })
      value.choose = true
      this.priceInfo = value
    },
    renewNow () {
      // 2ali 8wx
      let payType = null
      if (this.choosewx) payType = 8
      if (this.chooseali) payType = 2
      api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=234`)
      new Pay().renewalSass(this.priceInfo.busId, parseInt(payType), this.priceInfo.quantity)
    },
    ifShowLong (value) {
      if (this.versionInfo.agentId) {
        if (value.originalAmount === 1999) return false
      }
      return true
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>



// WEBPACK FOOTER //
// index.vue?a75ea262